import type { RouteObject } from 'react-router-dom';

export const fallbackRoutes: RouteObject[] = [
  {
    path: '*',
    lazy: async () => ({
      Component: (await import('@pages/error')).NotFoundPage,
    }),
  },
];
